import { useState, useEffect } from 'react'
import './App.css'
import AuthStatus from './components/AuthStatus'
import UserInfo from './components/UserInfo'
import { useTelegramWebApp } from './hooks/useTelegramWebApp'
import { validateInitData } from './services/api'

function App() {
  const { tg, initData, isReady } = useTelegramWebApp()
  const [validationResult, setValidationResult] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (isReady && initData) {
      handleValidate()
    }
  }, [isReady, initData])

  const handleValidate = async () => {
    if (!initData) {
      setError('Init data tidak tersedia')
      return
    }

    setLoading(true)
    setError(null)

    try {
      const result = await validateInitData(initData)
      setValidationResult(result)
    } catch (err) {
      setError(err.message || 'Terjadi error saat validasi')
      setValidationResult(null)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="app">
      <div className="container">
        <header className="header">
          <h1>Telegram Mini App</h1>
          <p className="subtitle">Validasi Init Data</p>
        </header>

        <AuthStatus 
          isValid={validationResult?.valid}
          loading={loading}
          error={error}
        />

        {validationResult?.user && (
          <UserInfo user={validationResult.user} />
        )}

        <div className="actions">
          <button 
            onClick={handleValidate}
            disabled={loading || !initData}
            className="btn btn-primary"
          >
            {loading ? 'Memvalidasi...' : 'Validasi Ulang'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default App

